import { render, staticRenderFns } from "./ModuleInformationEditModal.vue?vue&type=template&id=d10e6b5e&scoped=true&"
import script from "./ModuleInformationEditModal.vue?vue&type=script&lang=js&"
export * from "./ModuleInformationEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ModuleInformationEditModal.vue?vue&type=style&index=0&id=d10e6b5e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10e6b5e",
  null
  
)

export default component.exports